import { render, staticRenderFns } from "./mealstas.vue?vue&type=template&id=33fdd786&scoped=true&"
import script from "./mealstas.vue?vue&type=script&lang=js&"
export * from "./mealstas.vue?vue&type=script&lang=js&"
import style0 from "./mealstas.vue?vue&type=style&index=0&id=33fdd786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fdd786",
  null
  
)

export default component.exports